import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NzTreeComponent } from 'ng-zorro-antd/tree';
import { EmopPublicUsercenterSelectorService } from './emop-public-usercenter-selector-api.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'emop-public-usercenter-selector',
  templateUrl: './emop-public-usercenter-selector.component.html',
  styleUrls: ['./emop-public-usercenter-selector.component.scss']
})
export class EmopPublicUsercenterSelectorComponent implements OnInit {
  /**
   * 数据列表
   */
  dataList = [];
  /**
   * 搜索关键词
   */
  keyword = '';
  /**
   * 加载状态
   */
  loading: boolean = false;
  /**
   * 是否允许多选
   */
  @Input() multiple: boolean = false;
  /**
   * 已选中的人员id列表
   */
  @Input() checkedIds: string[] = [];

  @ViewChild('nzTreeComponent', { static: false }) nzTreeComponent!: NzTreeComponent;
  @Output() submit = new EventEmitter;
  constructor(
    private EmopPublicUsercenterSelectorService: EmopPublicUsercenterSelectorService,
    private NzNotificationService: NzNotificationService
  ) { }

  ngOnInit(): void {
    this.lazyChildren(true);
  }

  nzCheck(): void {
    const list = this.nzTreeComponent.getCheckedNodeList();
    // 单选时清空之前选中的用户
    if (!this.multiple && list.length > 1) list[0].isChecked = false;
  }
  /**
   * 
   * @param isFirst 是否初始渲染
   * @param e 树组件的展开事件
   */
  lazyChildren(isFirst: boolean, e?) {
    if (isFirst || (e.node.origin.expanded && !e.node.origin.children?.length)) {
      if (isFirst) {
        this.loading = true;
      } else {
        e.node.isLoading = true;
      }
      this.EmopPublicUsercenterSelectorService.lazyChildren(isFirst ? '0' : e.node.origin.key, this.keyword).subscribe((rs) => {
        if (rs.data.length) {
          const insertData = this.dealWithData(rs.data);
          if (isFirst) {
            this.dataList = insertData;
            this.loading = false;
          } else {
            e.node.addChildren(insertData);
            e.node.isLoading = false;
          }
        } else {
          e.node.isLoading = false;
          e.node.isLeaf = true;
        }
        this.checkedIds = [...this.checkedIds];
      });
    }
  }
  submitFn(type: 'insert' | 'save') {
    const result = this.nzTreeComponent?.getCheckedNodeList();
    if (!result?.length) return this.NzNotificationService.info('保存失败', '至少选择一名用户');
    this.submit.emit({
      type,
      data: result.map(item => item.origin.data)
    });

  }
  search() {
    this.dataList = [];
    this.loading = true;
    this.EmopPublicUsercenterSelectorService.lazyChildren('0', this.keyword).subscribe((rs) => {
      this.dataList = this.dealWithData(rs.data);
      this.loading = false;
    });
  }
  /**
   * 数据处理成树节点数据
   * @param data 
   * @returns 
   */
  dealWithData(data) {
    return data.map(item => {
      // 如果是用户,则特殊处理
      let title = item.data.deptName;
      let children = [];
      let isLeaf = false;
      let disableCheckbox = true;
      // 多选时允许选择部门,单选不允许选择部门
      // if (this.multiple) {
      //   disableCheckbox = false;
      // } else {
      //   disableCheckbox = true;
      // }
      if (item.data.name) {
        title = `${item.data.name}[${item.data.account}]`;
        children = null;
        isLeaf = true;
        disableCheckbox = false;
      }
      return {
        data: item.data,
        title,
        key: item.data.id,
        children,
        isLeaf,
        disableCheckbox
      };
    });
  }
}
